import React, { useContext, useEffect, useRef, useState } from 'react'
import { IncomingCall } from '~/service/SipConn'
import { get } from '~/utils/api'
import { User, UsersManagerContext } from '~/service/UsersManager'
import { FormattedMessage } from '~/translations/utils'
import { useMounted } from '~/hooks/mounted'

type Props = {
  call: IncomingCall
}

type ApiUser = {
  id: number
  internal: number
}

type TransferUser = User & {
  internal: number
}

const Transfer: React.FC<Props> = ({ call }) => {
  const [users, setUsers] = useState<TransferUser[]>()

  const { get: getUser } = useContext(UsersManagerContext)

  const setUsersRef = useRef(setUsers)

  const mountedRef = useMounted()

  useEffect(() => {
    const download = async () => {
      const agents = (await get('agent/available')) as ApiUser[]

      if (!mountedRef.current) {
        return
      }

      setUsersRef.current(
        agents
          .map(apiUser => ({
            internal: apiUser.internal,
            user: getUser(apiUser.id),
          }))
          .filter(({ user }) => user)
          .map(({ internal, user }) => ({ ...(user as User), internal }))
      )
    }

    download()

    const interval = setInterval(download, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  const callAgent = (internal: number) => {
    call.setTransferStatus('started')

    const internalStr = internal + ''

    call.sendDtmf('#')

    for (let i = 0; i < internalStr.length; i++) {
      setTimeout(() => {
        call.sendDtmf(internalStr.charAt(i))

        if (i == internalStr.length - 1) {
          call.setTransferStatus('dtmfSent')
        }
      }, 1000 + i * 500)
    }
  }

  const acceptTransfer = () => {
    call.setTransferStatus('accepted')
    call.sendDtmf('#')
  }

  const cancelTransfer = () => {
    call.setTransferStatus(false)
    call.sendDtmf('*')
  }

  return (
    <div className="phone-transfer">
      {!call.transferStatus ? (
        !users ? null : users.length > 0 ? (
          users.map(user => (
            <button
              className="button is-default"
              key={user.id}
              onClick={() => callAgent(user.internal)}
            >
              <img src={user.avatar} />
              {user.name}
            </button>
          ))
        ) : (
          <FormattedMessage id="phone / call / transfer / no users" />
        )
      ) : (
        <>
          <button
            className="button is-success"
            onClick={() => acceptTransfer()}
            disabled={call.transferStatus == 'started'}
          >
            <span className="icon">
              <span className="fa fa-check" />
            </span>
            <span>
              <FormattedMessage id="phone / call / transfer / accept" />
            </span>
          </button>
          <button
            className="button is-danger"
            onClick={() => cancelTransfer()}
            disabled={call.transferStatus == 'started'}
          >
            <span className="icon">
              <span className="fa fa-times" />
            </span>
            <span>
              <FormattedMessage id="phone / call / transfer / cancel" />
            </span>
          </button>
        </>
      )}
    </div>
  )
}

export default Transfer
